<template>
	<div class="upload-container">
		<div style="text-align: center;" v-if="loading" class="mb-20">
	    <i class="el-icon-loading" style="font-size:22px"></i>{{ $t('message.uploading') }}
	  </div>
	                  
		<el-upload 
				ref="uploadFile"
		    drag
		    :multiple="false"
		    class="avatar-uploader"
		    :action="`/api/file/upload/${usage}`"
		    :show-file-list="false"
		    :on-success="handleAvatarSuccess"
		    :before-upload="beforeAvatarUpload"
		    :on-progress="avatarProgress"
        :on-change="avatarChanged">
		  <img v-if="imageUuid" :src="showImage(imageUuid)" :class="avatar">
		  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
		  <div slot="tip" class="el-upload__tip">{{ $t(fileLimit) }}</div>
		</el-upload>
	</div>
</template>

<script>

export default {
	name: 'UploadWidget',
	props:{
		uuid:String,
		usage:String,
		avatar:{
			type:String,
			default:'avatar'
		},
		fileLimit:{
			type:String,
			default: 'profile.form.file_limit'
		}
	},
	data(){
		return {
			loading: false
		}
	},
	computed: {　//運用computed，讓父組件的值可以在子組件裡修改
		imageUuid: {
	    get() {　
	      return this.uuid;　//讀props，表示從父組件取得值
	    },
	    set(f) {//更新時，通知父組件更新，就會讓父組件傳新的值給子組件
	      this.$emit('uploadSuccess', f)
	    }
	  }
	},
	methods:{
		handleAvatarSuccess(res, file) {
			console.log('handleAvatarSuccess')
      if (res.error) {
        this.showResult('error', this.$t('action.upload_error', {'err': res.error}))
      } else {
      	console.log('upload:', res)
      	this.imageUuid = res
      }
    },
    beforeAvatarUpload(file) {
    	console.log('beforeAvatarUpload:')
    	console.log(file)

    	const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
	      const isLt3M = file.size / 1024 / 1024 < 3;

	      if (!isJPG) {
	        this.$message.error('限上傳 jpg、png 格式');
	        return false
	      }
	      if (!isLt3M) {
	        this.$message.error('圖片大小超過 3M');
	        return false
	      }


	      // var _URL = window.URL || window.webkitURL;
				// $("#file").change(function (e) {
				//     var file, img;
				//     if ((file = this.files[0])) {
				//         img = new Image();
				//         var objectUrl = _URL.createObjectURL(file);
				//         img.onload = function () {
				//             alert(this.width + " " + this.height);
				//             _URL.revokeObjectURL(objectUrl);
				//         };
				//         img.src = objectUrl;
				//     }
				// });

	      // const reader = new FileReader();
	    	// reader.onload = (e) => {
			  //   const image = new Image();
			  //   image.src = e.target.result;
			  //   image.onload = () => {
			  //   	console.log('uploading......')
			  //     const { height, width } = image;
			  //     if (height != 2000 && width != 1400) {
			  //       this.$message.error('圖片尺吋需為 2000x1400');

			  //       return false;
			  //     } 
			  //   };
			  // };

	      // return isJPG && isLt3M;

    	
    	// const reader = new FileReader();
    	// reader.readAsDataURL(file);
    	// reader.onload = (e) => {
		  //   const image = new Image();
		  //   image.src = e.target.result;
		  //   image.onload = () => {
		  //     const {
		  //       height,
		  //       width
		  //     } = image;
		  //     console.log('height:', height)
		  //     console.log('width:', width)
		  //     if (height != 2000 && width != 1400) {
		  //       this.$message.error('圖片尺吋需為 2000x1400');
		  //       return false;
		  //     } else {
		  //     	const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
			//       const isLt3M = file.size / 1024 / 1024 < 2;

			//       if (!isJPG) {
			//         this.$message.error('限上傳 jpg、png 格式');
			//       }
			//       if (!isLt3M) {
			//         this.$message.error('圖片大小超過 2M');
			//       }
			//       return isJPG && isLt3M;
		  //     }
		  //   };
		  // };
		  

      
    },
    avatarProgress(){
      this.loading = true
      console.log("avatarProgress.....")
    },
    avatarChanged(){
      this.loading = false
      console.log("avatarChanged.....")
    },
	},
	mounted(){

	}
}

</script>

<style scoped>
.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100%;
  height: 178px;
  display: block;
  object-fit: contain;
}
.icon {
  width: 100%;
  height: 50px;
  display: block;
  object-fit: contain;
}

.upload-container{
	float: left;
}

/*/deep/ .el-upload-dragger {
  width: 180px !important;
}*/

</style>


